import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'generateFullNumberOrder'
})
export class GenerateFullOrderNumberPipe implements PipeTransform {
  transform(invoiceId: string, sequentId: string): string {
    return (sequentId ? sequentId : '') + (invoiceId ? ' (' + invoiceId + ') ' : '');
  }
}
